import { useState, useEffect } from 'react';
import { listPizzerias, setPizzeriaStatus as updatePizzeriaStatus } from '../services/api';

const usePizzerias = (page, limit, filters) => {
  const [pizzeriasData, setPizzeriasData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPizzerias = async () => {
    try {
      setLoading(true);
      const response = await listPizzerias(page, limit, filters);
      const { data, status } = response;
      if (status === 200) {
        setPizzeriasData(data);
      } else if (status === 204) {
        setPizzeriasData({});
      } else {
        throw new Error('Failed to fetch pizzerias');
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchPizzerias();
  }, [page, limit, filters]);

  return { pizzeriasData, loading, error, setPizzeriasData };
};

export default usePizzerias;
